import { useMutation } from "@tanstack/react-query";
import { useSetUserContext, useUserContext } from "./useUserContext";
import { updateUserWalkThrough } from "../_firebase/user";

const useUpdateWalkThrough = () => {
  const setUser = useSetUserContext();
  const user = useUserContext();
  const mutation = useMutation({
    mutationFn: ({
      walkThroughCompleted,
      skippedAtStep,
    }: {
      walkThroughCompleted: boolean;
      skippedAtStep?: number;
    }) => updateUserWalkThrough(user, walkThroughCompleted, skippedAtStep),
    onSuccess: (updatedUser) => {
      setUser(updatedUser!);
    },
  });

  return mutation;
};

export default useUpdateWalkThrough;
